<template>
  <div class="imgInfo mt-50 font-14 ml-30">
    <el-form :model='ruleForm' :inline="true" :rules="rules" ref="ruleForm" label-width="100px">
      <div>
        <el-form-item label="主图上传:" prop="imgMain">
          <multipleImgUpload
              :multiple="true"
              :width="180"
              :height="180"
              :dialogImageUrlList="originalUrl"
              :max="1"
              :imgWidthAndHeight="600"
              @cloneDialogImageUrlList="cloneDialogOriginalUrl"
              :preview="true">
          </multipleImgUpload>
        </el-form-item>
        <el-form-item label="图片边框:" prop="imgMask">
          <multipleImgUpload
              :multiple="true"
              :width="180"
              :height="180"
              :dialogImageUrlList="maskPictureUrl"
              :max="1"
              :imgWidthAndHeight="600"
              @cloneDialogImageUrlList="cloneDialogMaskPictureUrl"
              :preview="true">
          </multipleImgUpload>
        </el-form-item>
        <el-form-item label="效果图:">
            <div class="imgDiv mt-10">
              <img v-if="originalUrl[0]" :src="originalUrl[0].url" alt="">
              <img v-if="maskPictureUrl[0]" :src="maskPictureUrl[0].url" alt="">
            </div>
        </el-form-item>
      </div>
      <div style="margin-left:100px">
        <div style="margin-bottom:10px">
          主图上传标准600*600单图，图片框架为600*600单图，都只可1张，可编辑。标准大小不超过1M。
        </div>
        <el-form-item label="">
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </div>
      <el-divider/>
      <div>
        <el-form-item label="副图商品:">
          <multipleImgUpload
              :multiple="true"
              :width="180"
              :height="180"
              :dialogImageUrlList="fileList"
              :max="6"
              :imgWidthAndHeight="600"
              @cloneDialogImageUrlList="cloneDialogImageUrlList"
              :preview="true">
          </multipleImgUpload>
        </el-form-item>
      </div>
      <div style="margin-left:100px">
        <div style="margin-bottom:10px">
          副图上传标准600*600单图，大小不超过1M，至少1张，正面，背面，侧面（清晰的upc图），或者整箱包装图、多瓶图。
        </div>
        <el-form-item label="">
          <el-button type="primary" @click="updateMedia('ruleForm')">保存</el-button>
        </el-form-item>
      </div>
      <el-divider/>
       <div>
        <el-form-item label="商品视频:">
          <videoUpload :isVideo="true" v-model="videoInfo.videoUrl"/>
        </el-form-item>
        <el-form-item label="视频封面:">
          <videoUpload v-model="videoInfo.fileUrl"/>
        </el-form-item>
      </div>
      <div style="margin-left:100px">
        <div style="margin-bottom:10px">
          商品视频上传标准MP4格式，大小不超过50M；视频封面上传标准600*600单图，大小不超过1M。
        </div>
        <el-form-item label="">
          <el-button type="primary" @click="updateVideo">保存</el-button>
        </el-form-item>
      </div>

    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>

import { updateMainImages, updateImages, getPicture, updateVideo } from "~/api/axiosInfo"
export default {
  props:['skuInfo',],
  data(){
    var validateImgMain = (rule, value, callback) => {
      if (this.originalUrl.length === 0) {
        callback(new Error('请上传图片'));
      } else {

        callback();
      }
    };
    var validateImgMask = (rule, value, callback) => {
      if (this.maskPictureUrl.length === 0) {
        callback(new Error('请上传图片'));
      } else {

        callback();
      }
    };
    
    return{
      ruleForm:{
       
      },
      videoInfo:{
        skuId:null,
        fileUrl:null,
        videoUrl:null,
      },
      limit:3,
      rules:{
        imgMain:[
          { required: true, validator: validateImgMain}
        ],
        imgMask:[
          { required: true, validator: validateImgMask}
        ]
      },
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      uploadDisabled:false,
      newList: [],
      fileList:[],
      originalUrl: [],
      maskPictureUrl:[],
    }
  },
  watch:{
    skuInfo(val){
      if(val.skuShowVideoVO){ // 视频
        this.videoInfo.fileUrl = val.skuShowVideoVO.fileUrl
        this.videoInfo.videoUrl = val.skuShowVideoVO.videoUrl
      }
      this.getInit()
    },

  },
  mounted(){
    
  },
  methods:{
    cloneDialogOriginalUrl(val) {
        this.originalUrl = val
        this.$refs.ruleForm.validateField('imgMain');
    },
    cloneDialogMaskPictureUrl(val) {
        this.maskPictureUrl = val
        this.$refs.ruleForm.validateField('imgMask');
    },
    cloneDialogImageUrlList(val) {
        this.fileList = val
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            skuNo: this.skuInfo.skuNo,
            originalUrl:this.originalUrl[0].url,
            maskPictureUrl:this.maskPictureUrl[0].url,
          }
          this.mainImageSave(data)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    mainImageSave(data){
      updateMainImages(data).then(res=>{
        this.$message({
            type: 'success',
            message: '修改成功!',
            duration: 1000
        });
        this.$emit('updateBase')
      }).catch(err=>{

      })
    },
    updateVideo(){
      this.videoInfo.skuId=this.skuInfo.id
      updateVideo(this.videoInfo).then(res=>{
        this.$message({
            type: 'success',
            message: '修改成功!',
            duration: 1000
        });
        this.$emit('updateBase')
      }).catch(err=>{

      })
    },
    //多媒体设置
    updateMedia(){
        if (this.fileList.length<3) {
          this.$message.warning('请上传至少3张副图！');
          return
        }
        let flag = false;
        let skuShowPictureParam = [];
        for(let i = 0;i<this.fileList.length;i++){
            let v = this.fileList[i];
            if(v.url.indexOf('blob') != -1){
                this.$message.warning('图片上传中');
                flag = true
                break
            }else{
                skuShowPictureParam.push({
                    fileUrl:v.url,
                    fileType:1
                })
            }
        }
        if(flag) return
        let body = {
            id:this.skuInfo.id,
            skuShowPictureParam
        };
        this.updateImagesList(body)
    },
    
    updateImagesList(data){
      updateImages(data).then(res=>{
        this.$message({
            type: 'success',
            message: '修改成功!',
            duration: 1000
        });
        // this.$emit('updateBase')
      }).catch(err=>{

      })
    },
    getInit(){
      getPicture({skuNo:this.skuInfo.skuNo}).then(res=>{
        if(res.originalUrl){
          this.originalUrl = [{url:res.originalUrl}]
        }
        if(res.maskPictureUrl){
          this.maskPictureUrl = [{url:res.maskPictureUrl}]
        }
        if(res.subplotList.length>0){
          this.fileList = res.subplotList.map(item=>{
            item.url = item.fileUrl
            return item
          })
        }
      }).catch(err=>{

      })
    }
  },
}
</script>

<style lang="less">
.imgInfo{
  .el-upload--picture-card{
    width: 180px;
    height: 180px;
  }
  .imgDiv{
    width: 180px;
    height: 180px;
    position: relative;
    img{
      width: 180px;
      height: 180px;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
    }
  }
}
</style>